import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import PageLoader from "../components/PageLoader";

const AppLayout = () => {
  const location = useLocation();
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    setRouteLoading(true);
    const timer = setTimeout(() => {
      setRouteLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {routeLoading && <PageLoader />}
      <Outlet context={{ routeLoading }} />
    </>
  );
};

export default AppLayout;
